/**
 * Alias of the common library's `OtpVerificationStatus`.
 */
// Deep import, not the 95-module `dist/models` barrel: this re-export is a value (an enum), so
// it survives emit and every importer of this file would otherwise pay for the whole barrel.
export { OtpVerificationStatus as OneTimePasscodeStatus } from 'coo-transactions-common-library/dist/models/otp-verification-status';
